<template>
    <!-- eslint-disable vue/no-use-v-if-with-v-for,vue/no-template-key -->
    <div class="autocompleteWrapper">

        <span v-if="isLoading" class='loading'></span>
        <input :readonly="isLoading" ref="input" type="text" class="autocompleteInput" autocomplete="off"
               :placeholder="placeholder"
               @focus="focus"
               @keydown.down="event => changeHighlight(1, event)"
               @keydown.up="event => changeHighlight(-1, event)"
               @keydown.esc="cancel"
               @keydown.enter="selectResult"
               v-bind:value="value"
               v-on:input="$emit('input', $event.target.value)"
        />
        <span v-if="!isLoading && cancellable" class='cancelButton' @click="cancel()">close</span>
        <ul ref="list" v-show="!isLoading && showResults && options.length" class="autocomplete-results">
            <li v-for="(option, i) in options"
                @click="selectResult(i)"
                :key="i"
                class="autocomplete-result"
                :class="{'selected':(i === highlightIndex)}">
                <slot v-if="option.slotKey" :name="'item-' + option.slotKey" v-bind:option="option" v-bind:input="value">
                    ERRRORR!!<!--                //TODO double check slots are defined for all slot names. Also, have selected class in here, as this is gross-->
                </slot>
                <slot v-else name="item" v-bind:option="option">
                    {{option}}
                </slot>
            </li>
        </ul>
    </div>
</template>

<script>
  export default {
    name: "Autocomplete",
    props: {
      formatResultFunction: {type: Function, default: result => result},
      placeholder: {type: String},
      //TODO link required status of createNew
      cancellable: {type: Boolean, default: true},
      initializeWhenDone: {type: Boolean, default: true},
      value: {type: String},
      startFocused: {type: Boolean, default: false},
      options: {type: Array, required: true},
      loadingCount: {type: Number}
    },
    data() {
      return {
        highlightIndex: -1,
        showResults: false
      };
    },
    mounted: function () {
      if (this.startFocused) {
        this.$refs.input.focus();
      }
      document.addEventListener('click', this.deFocus);
    },
    destroyed: function () {
      document.removeEventListener('click', this.deFocus);
    },

    computed: {
      isLoading() {
        return this.loadingCount > 0;
      },
      selectedOption() {
        return this.options[this.highlightIndex];
      }
    },
    methods: {
      changeHighlight(movement, event) {
        let newIndex = this.highlightIndex + movement;
        if (newIndex < -1 || newIndex > (this.options.length)) {
          //Out of bounds, don't move
        } else {
          this.highlightIndex = newIndex;
          event.preventDefault();
        }
      },
      focus() {
        this.highlightIndex = -1;
        this.showResults = true;
      },
      deFocus(event) {
        //Cancel if click is outside this element. (and click is in a real DOM node)
        let newElement = event.target;
        if (document.activeElement === this.$refs.input ) {
          //Do nothing if the element is still active
        }
        else if (newElement.parentElement && !this.$el.contains(newElement)) {
          this.cancel();
          this.showResults = false;
        }
      },
      cancel() {
        if (this.initializeWhenDone) {
          this.$emit('input', "");
          this.highlightIndex = -1;
        }
        this.$emit('cancel');
      },
      initialize() {
        if (this.initializeWhenDone) {
          this.$emit('input', "");
          //this.input = "";
          this.highlightIndex = -1;
          this.$refs.input.focus();
        } else {
          this.$refs.input.blur();
          this.showResults = false;
        }
      },
      selectResult(selectionIndex) {  //TODO refactor cleaner branching
        if (typeof selectionIndex === "number") {
          this.highlightIndex = selectionIndex;
        }
        this.$emit('select', this.selectedOption, this.value);
        this.initialize();
      }
    },
    watch: {
      options() {
        //Auto-select if 1 option
        if (this.options.length === 1) {
          this.highlightIndex = 0;
        } else if (this.highlightIndex > this.options.length) {
          this.highlightIndex = -1;
        }
        //Keep options on screen;
        this.$nextTick(() => {
          if (this.showResults && this.$refs.list.getBoundingClientRect().bottom > window.innerHeight) {
            this.$refs.list.scrollIntoView({block: "end", inline: "nearest", behavior: "smooth"})
          }
        });
      }
    }
  }

</script>

<style scoped lang="scss">
    .autocompleteWrapper {
        position: relative;
    }

    .cancelButton {
        content: 'close';
        font-family: 'Material Icons';
        text-decoration: none;
        user-select: none;
        outline: none;
        //border-right: 1px solid grey;
        margin-right: 0.2em;
        font-size: 1.5em;
        width: 1em;
        flex-grow: 0;
        cursor: pointer;
        z-index: 1;
        color: grey;
    }

    .autocompleteInput {
        position: relative;
        text-align: left;
        width: 12em; //Magic value?
        //max-width: 100%;
        //outline: none;
        //height: 16px;
    }

    @keyframes loading1 {
        to {transform: rotate(360deg);}
    }

    @keyframes loading2 {
        from {transform: rotate(45deg);}
        to {transform: rotate(405deg);}
    }

    .loading:before, .loading:after {
        content: '';
        box-sizing: border-box;
        position: absolute;
        top: 50%;
        left: 2px;
        width: 1em;
        height: 1em;
        margin-top: -0.5em;
        border-radius: 50%;
        border: 2px solid #ccc;
        border-top-color: mediumblue;
        animation: loading1 1s cubic-bezier(0.32, 0.1, 0.68, 0.9) infinite;
    }
    .loading:after {
        border-color: rgba(255,255,255, 0);
        border-top-color: mediumblue;
        transform: rotate(45deg);
        animation-name: loading2
    }


    .autocomplete-results {
        position: absolute;
        top: 100%;
        background: white;
        padding: 0;
        margin: 5px 0 0 0;
        border: 1px solid #cccccc;
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
        height: auto;
        width: calc(100%);
        box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.7);
        z-index: 1000000;
    }

    .autocomplete-results > li {
        list-style: none;
        text-align: left;
        padding: 0.35em 0.5em;
        cursor: pointer;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .autocomplete-results > li:last-child {
        border-bottom: 0;
    }
    .autocomplete-results > li:first-child {
        border-top: 0;
    }

    .autocomplete-results > li.createNew {
        border-top: lightgrey 1px solid;
    }


    .autocomplete-results > li:hover {
        background-color: $editColor2;
        color: white;
    }
    .autocomplete-results > li.selected {
        background-color: $editColor;
        color: white;
    }

    /*input:not(:focus) + ul  {*/
    /*  display: none;*/
    /*}*/
    //TODO only show border if ul has contents (autocomplete no location as example)
</style>
